import React from 'react';
import { Seo } from '../components/Seo';
import { pageSeo } from '../data/seo';
import { technologyJsonLd } from '../data/structuredData';
import { HowItWorks } from '../components/HowItWorks';
import { ComparisonTable } from '../components/ComparisonTable';
import { FaqSection } from '../components/FaqSection';
import { TextCta } from '../components/TextCta';
import { TextButton } from '../components/TextButton';
import { smsMessages } from '../utils/sms';
const proof = [{
  label: 'Independently validated',
  body: 'Performance testing conducted by the Water Institute in Phoenix, Arizona \u2014 not by us.'
}, {
  label: 'Patented Fusion 44X process',
  body: 'Hydro-pH-Infusion is protected by patented innovation and confidential process engineering.'
}, {
  label: 'Legal in all 50 states',
  body: 'Hydrosprings falls within pool and spa regulations in every state.'
}, {
  label: 'DC powered by design',
  body: 'Low-voltage DC operation limits any risk of shock or electrical fault.'
}];
export function Technology() {
  return <main data-id="element-339" data-mp="285f21z5c914j">
      <Seo {...pageSeo.technology} jsonLd={technologyJsonLd} data-id="element-340" data-mp="2856u8lo2om07" />
      <section className="bg-canvas pb-16 pt-14 lg:pb-20 lg:pt-20" data-id="element-341" data-mp="283cfjp3e9q4k">
        <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-342" data-mp="1u4vxj2030d74">
          <div className="grid gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:items-end lg:gap-20" data-id="element-343" data-mp="1y6zdo3xp45yq">
            <div data-id="element-344" data-mp="1kful1lsqwdxw">
              <p className="mb-4 text-xs uppercase tracking-[0.18em] text-aqua-600" data-id="element-345" data-mp="1kfce9v8gihbq">
                The technology
              </p>
              <h1 className="max-w-3xl font-display text-[38px] font-semibold leading-[1.03] tracking-tightest text-ink-950 sm:text-[52px]" data-id="element-346" data-mp="1p85jek7u7roc">
                Can you drink your pool water?
              </h1>
              <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-ink-700" data-id="element-347" data-mp="1fhazhmi2d462">
                Hydrosprings installs Fusion 44X. It isn&rsquo;t a new filter.
                It isn&rsquo;t a better chlorine. It is the end of chlorine
                &mdash; reinventing pool water for families, for the
                environment, and for the future.
              </p>
              <p className="mt-5 max-w-xl font-display text-xl font-medium leading-snug tracking-tight text-ink-950" data-id="element-348" data-mp="33dhbo11i1tu0">
                &ldquo;Say goodbye to red eyes, dry skin, and the chlorine
                smell.&rdquo;
              </p>
              <TextButton message={smsMessages.general} size="lg" className="mt-8" data-id="element-349" data-mp="2ubre0dh0xyns">
                Text us
              </TextButton>
            </div>

            <figure className="overflow-hidden rounded-2xl" data-id="element-350" data-mp="3i3et7y4xbla8">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/585504d6-3177-4284-bf1d-b354b86ae99c.jpg" alt="A glass of clear water drawn from a Hydrosprings pool, with fine hydrogen bubbles" className="aspect-[4/3] w-full object-cover" data-id="element-351" data-mp="3i1vh8jqavwe9" />
            </figure>
          </div>

          <dl className="mt-16 grid gap-px overflow-hidden rounded-2xl bg-ink-950/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-352" data-mp="h7nx4pp3bk66">
            {proof.map(item => <div key={item.label} className="bg-paper p-7" data-id="element-353" data-mp="m44m1m4462kb">
                <dt className="font-display text-base font-semibold text-ink-950" data-id="element-354" data-mp="q6rgzvw303lq">
                  {item.label}
                </dt>
                <dd className="mt-2.5 text-sm leading-relaxed text-ink-700" data-id="element-355" data-mp="v0nd0sssbge9">
                  {item.body}
                </dd>
              </div>)}
          </dl>
        </div>
      </section>

      <HowItWorks data-id="element-356" data-mp="14ytbt1jao6ew" />
      <ComparisonTable data-id="element-357" data-mp="19vthvcg59960" />

      <section className="border-t border-ink-950/8 bg-canvas py-20 lg:py-24" data-id="element-358" data-mp="19vjrhnr6szzs">
        <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-359" data-mp="1dx4zauov6o34">
          <blockquote className="mx-auto max-w-3xl text-center font-display text-2xl font-medium leading-[1.25] tracking-tight text-ink-950 sm:text-[34px]" data-id="element-360" data-mp="1dwlt2b8kto4x">
            &ldquo;This is more than a pool product. This is about your health,
            your children, and the future of eco-conscious pool care.&rdquo;
          </blockquote>
        </div>
      </section>

      <FaqSection data-id="element-361" data-mp="2gbyf6mymqvye" />
      <TextCta data-id="element-362" data-mp="2gcgj85rjaegv" />
    </main>;
}